import { render } from "./contactComponent.vue?vue&type=template&id=19d1bba5"
import script from "./contactComponent.vue?vue&type=script&lang=js"
export * from "./contactComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__